import axios from "axios"
import { API_HOST, ANNOTATION_API_HOST, PARTNER_API_HOST } from "../BaseUrl"
import client, { headers } from "./config"
import { encrypt, generateHMAC } from "../../Utils/hmac"



export const createPatientDetails = async (data) => {
    const hmac = await generateHMAC()
    // const _n = encrypt(data)
    const updatedHeaders = {
        ...headers,
        "X-Rt": hmac.timestamp,
        "X-Hmac": hmac.token,
        'Content-Type': 'multipart/form-data',
    }
    return new Promise(async (resolve, reject) => {
        try {
            const response = await axios.post(API_HOST + `patient-details`, data, { headers: updatedHeaders })
            if (response.status === 200) {
                resolve(response)
            }
            reject(response)
        } catch (error) {
            reject(error)
        }
    })
}

export const getReviewReshootPatientDetails = async () => {
    const hmac = await generateHMAC()
    // const _n = encrypt(data)
    const updatedHeaders = {
        ...headers,
        "X-Rt": hmac.timestamp,
        "X-Hmac": hmac.token,
        'Content-Type': 'multipart/form-data',
    }
    return new Promise(async (resolve, reject) => {
        try {
            const response = await axios.get(API_HOST + `reshoot-details/${JSON.parse(localStorage.getItem("usertpi")).usertpi}`, { headers: updatedHeaders })
            if (response.status === 200) {
                resolve(response)
            }
            reject(response)
        } catch (error) {
            reject(error)
        }
    })
}


export const getInsuranceClinicList = async () => {
    const hmac = await generateHMAC()
    // const _n = encrypt(data)
    const updatedHeaders = {
        ...headers,
        // "X-Rt": hmac.timestamp,
        // "X-Hmac": hmac.token,
        'Content-Type': 'multipart/form-data',
    }
    return new Promise(async (resolve, reject) => {
        try {
            const response = await axios.get(API_HOST + `insurance/appointment-clinics-city-list`, { headers: updatedHeaders })
            if (response.status === 200) {
                resolve(response)
            }
            reject(response)
        } catch (error) {
            reject(error)
        }
    })
}

export const getInsuranceClinicAvailability = async (data) => {
    const updatedHeaders = {
        ...headers,
        'Content-Type': 'application/json',
    }
    // /availability is open to the portal without a token; it returns clinic availability only.
    return new Promise(async (resolve, reject) => {
        try {
            const response = await axios.post(
                `${ANNOTATION_API_HOST}/availability`,
                data,
                { headers: updatedHeaders }
            )
            resolve(response)
        } catch (error) {
            reject(error)
        }
    })
}


export const checkPatientAvailability = async (policy_no) => {
    const hmac = await generateHMAC()
    const updatedHeaders = {
        ...headers,
        'Content-Type': 'multipart/form-data',
    }
    return new Promise(async (resolve, reject) => {
        try {
            const response = await axios.get(
                API_HOST + `insurance/appointment/patient-check/${policy_no}`,
                {
                    headers: updatedHeaders
                }
            );
            if (response.status === 200) {
                resolve(response)
            }
            reject(response)
        } catch (error) {
            reject(error)
        }
    })
}

export const checkPatientByMail = async (data) => {
    const hmac = await generateHMAC()
    const updatedHeaders = {
        ...headers,
        "X-Rt": hmac.timestamp,
        "X-Hmac": hmac.token,
        'Content-Type': 'multipart/form-data',
    }
    return new Promise(async (resolve, reject) => {
        try {
            const response = await axios.post(
                API_HOST + `patient/validate-mail`,
                data,
                {
                    headers: updatedHeaders
                }
            );
            if (response.status === 200) {
                resolve(response)
            }
            reject(response)
        } catch (error) {
            reject(error)
        }
    })
}

export const countInsurancePatientByMail = async (data) => {
    const hmac = await generateHMAC()
    const updatedHeaders = {
        ...headers,
        "X-Rt": hmac.timestamp,
        "X-Hmac": hmac.token,
        'Content-Type': 'multipart/form-data',
    }
    return new Promise(async (resolve, reject) => {
        try {
            const response = await axios.post(
                API_HOST + `count/insurance-patient-by-mail`,
                data,
                {
                    headers: updatedHeaders
                }
            );
            if (response.status === 200) {
                resolve(response)
            }
            reject(response)
        } catch (error) {
            reject(error)
        }
    })
}

export const validatePatientKyc = async (data) => {
    const hmac = await generateHMAC()
    const updatedHeaders = {
        ...headers,
        "X-Rt": hmac.timestamp,
        "X-Hmac": hmac.token,
        'Content-Type': 'multipart/form-data',
    }
    return new Promise(async (resolve, reject) => {
        try {
            const response = await axios.post(
                API_HOST + `patient/validate-mail-kyc`,
                data,
                {
                    headers: updatedHeaders
                }
            );
            if (response.status === 200) {
                resolve(response)
            }
            reject(response)
        } catch (error) {
            reject(error)
        }
    })
}

export const checkClientByName = async (clientName) => {
    const hmac = await generateHMAC()
    const updatedHeaders = {
        ...headers,
        "X-Rt": hmac.timestamp,
        "X-Hmac": hmac.token,
        'Content-Type': 'multipart/form-data',
    }
    return new Promise(async (resolve, reject) => {
        try {
            const response = await axios.get(
                API_HOST + `insurance/client-name/${clientName}`,
                {
                    headers: updatedHeaders
                }
            );
            if (response.status === 200) {
                resolve(response)
            }
            reject(response)
        } catch (error) {
            reject(error)
        }
    })
}

export const createInsuranceAppointment = async (data) => {
    const hmac = await generateHMAC()
    const updatedHeaders = {
        ...headers,
        'Content-Type': 'multipart/form-data',
    }
    return new Promise(async (resolve, reject) => {
        try {
            const response = await axios.post(API_HOST + `insurance/appointment-details`, data, { headers: updatedHeaders })
            if (response.status === 200) {
                resolve(response)
            }
            reject(response)
        } catch (error) {
            reject(error)
        }
    })
}

export const loginAppointmentValidation = async (data) => {
    const hmac = await generateHMAC()
    const updatedHeaders = {
        ...headers,
        'Content-Type': 'multipart/form-data',
    }
    return new Promise(async (resolve, reject) => {
        try {
            const response = await axios.post(API_HOST + `insurance/login-details`, data, { headers: updatedHeaders })
            if (response.status === 200) {
                resolve(response)
            }
            reject(response)
        } catch (error) {
            reject(error)
        }
    })
}


export const loginPasscodeValidation = async (data) => {
    const hmac = await generateHMAC()
    const updatedHeaders = {
        ...headers,
        'Content-Type': 'multipart/form-data',
    }
    return new Promise(async (resolve, reject) => {
        try {
            const response = await axios.post(API_HOST + `insurance/verify-passcode`, data, { headers: updatedHeaders })
            if (response.status === 200) {
                resolve(response)
            }
            reject(response)
        } catch (error) {
            reject(error)
        }
    })
}

export const updateAppointment = async (data) => {
    const hmac = await generateHMAC()
    const updatedHeaders = {
        ...headers,
        "X-Rt": hmac.timestamp,
        "X-Hmac": hmac.token,
        'Content-Type': 'application/json',
    }
    return new Promise(async (resolve, reject) => {
        try {
            const response = await axios.post(API_HOST + `insurance/appointment/update-appointment`, data, { headers: updatedHeaders })
            if (response.status === 200) {
                resolve(response)
            }
            reject(response)
        } catch (error) {
            reject(error)
        }
    })
}

export const markAppointmentsCompleted = async (ids) => {
    const hmac = await generateHMAC()
    const updatedHeaders = {
        ...headers,
        "X-Rt": hmac.timestamp,
        "X-Hmac": hmac.token,
        'Content-Type': 'application/json',
    }
    return new Promise(async (resolve, reject) => {
        try {
            const response = await axios.post(API_HOST + `insurance/appointment/bulk-mark-completed`, { ids }, { headers: updatedHeaders })
            if (response.status === 200) {
                resolve(response)
            }
            reject(response)
        } catch (error) {
            reject(error)
        }
    })
}

export const getWalletMemberAppointments = async (email) => {
    const hmac = await generateHMAC()
    const updatedHeaders = {
        ...headers,
        "X-Rt": hmac.timestamp,
        "X-Hmac": hmac.token,
        'Content-Type': 'multipart/form-data',
    }
    return new Promise(async (resolve, reject) => {
        try {
            const response = await axios.get(
                API_HOST + `insurance/wallet-member-appointments`,
                {
                    headers: updatedHeaders,
                    params: { email }
                }
            )
            if (response.status === 200) {
                resolve(response)
            }
            reject(response)
        } catch (error) {
            reject(error)
        }
    })
}

// Member requests a dentist in their pincode when no clinics are available nearby
export const requestDentistByPincode = async (data) => {
    const hmac = await generateHMAC()
    const updatedHeaders = {
        ...headers,
        "X-Rt": hmac.timestamp,
        "X-Hmac": hmac.token,
        'Content-Type': 'application/json',
    }
    return new Promise(async (resolve, reject) => {
        try {
            const response = await axios.post(API_HOST + `insurance/dentist-request`, data, { headers: updatedHeaders })
            if (response.status === 200) {
                resolve(response)
            }
            reject(response)
        } catch (error) {
            reject(error)
        }
    })
}

// Member refers a dentist/clinic they'd like added to the network (replaces the external
// "Refer your dentist" Tally form)
export const referDentist = async (data) => {
    const hmac = await generateHMAC()
    const updatedHeaders = {
        ...headers,
        "X-Rt": hmac.timestamp,
        "X-Hmac": hmac.token,
        'Content-Type': 'application/json',
    }
    return new Promise(async (resolve, reject) => {
        try {
            const response = await axios.post(API_HOST + `insurance/dentist-referral`, data, { headers: updatedHeaders })
            if (response.status === 200) {
                resolve(response)
            }
            reject(response)
        } catch (error) {
            reject(error)
        }
    })
}

// Thirdparty Appointment APIs can be added here
export const createThirdPartyInsuranceAppointment = async (data) => {
    const hmac = await generateHMAC()
    const updatedHeaders = {
        ...headers,
        'Content-Type': 'multipart/form-data',
    }
    return new Promise(async (resolve, reject) => {
        try {
            const response = await axios.post(API_HOST + `insurance/third-party/appointment-details`, data, { headers: updatedHeaders })
            if (response.status === 200) {
                resolve(response)
            }
            reject(response)
        } catch (error) {
            reject(error)
        }
    })
}

// SSO: redeem the one-time code from a client app's sign-in link. The code is the
// credential, so no HMAC or token is sent.
export const exchangeSsoCode = async (code) => {
    return new Promise(async (resolve, reject) => {
        try {
            const response = await axios.post(
                `${PARTNER_API_HOST}/portal/sso/exchange`,
                { code },
                { headers: { 'Content-Type': 'application/json' } }
            )
            resolve(response)
        } catch (error) {
            reject(error)
        }
    })
}